module.exports = __webpack_public_path__ + "img/view-to-lake.13210efc.svg";